export enum BORDER_TYPE {
  MATERIAL,
  BORDERED,
  FLOAT_LABEL,
  NOT_BORDERED,
}

export enum ValidateStatus {
  success = "success",
  warning = "warning",
  error = "error",
  validating = "validating",
}

export enum NUMBER_BUTTON {
  THREE = "three",
  TWO = "two",
}
export enum ADVANCE_DATE_RANGE_TYPE {
  SHORT,
  INPUT,
}

export enum ActionFilterEnum {
  ChangeAllField,
  ChangeOneField,
  ChangePageIndexPageSize,
  ChangeOrderType,
}

export enum UPLOADTYPE_IMAGE {
  IMAGE,
  AVATAR,
}

export enum MODAL_SIZE {
  SIZE_400 = 400,
  SIZE_600 = 600,
  SIZE_800 = 800,
  SIZE_1000 = 1000,
}

export enum NUMBER_TYPE {
  DECIMAL = "DECIMAL",
  LONG = "LONG",
}

export enum TAG_STATUS {
  SUCCESS = "SUCCESS",
  ERROR = "ERROR",
  INFO = "INFO",
  IN_PROGRESS = "IN_PROGRESS",
  DEFAULT = "DEFAULT",
  CLOSE = "CLOSE",
}
